import { lazy } from "react";
import { lazyImport } from "@src/utility/lazyImport";
import {Navigate} from "react-router-dom";

// const Landing = lazy(() => import("../../pages/landing"));
const { Clubs } = lazyImport(() => import("../../features/club"), "Clubs");
const { Club } = lazyImport(() => import("../../features/club"), "Club");
const { Team } = lazyImport(() => import("../../features/team"), "Team");
const { Landing } = lazyImport(
  () => import("../../features/landing"),
  "Landing"
);
const { Tournaments } = lazyImport(
  () => import("../../features/tournament"),
  "Tournaments"
);





const LandingRoutes = [
  {
    path: "/home",
    element: <Landing />,
    meta: {
      publicRoute: true,
      menuHidden: true,
      layout: "blank",
    },
  },
  // {
  //   path: "/clubs",
  //   element: <Clubs />,
  //   meta: {
  //     publicRoute: true,
  //     menuHidden: true,
  //     layout: "blank",
  //     action: "read",
  //     resource: "my_clubs",
  //   },
  // },
  // {
  //   path: "/clubs/:id",
  //   element: <Club />,
  //   meta: {
  //     publicRoute: true,
  //     menuHidden: true,
  //     layout: "blank",
  //     action: "read",
  //     resource: "club",
  //   },
  // },
  // {
  //   path: "/clubs/:id/team/:teamId",
  //   element: <Team />,
  //   meta: {
  //     publicRoute: true,
  //     menuHidden: true,
  //     layout: "blank",
  //     action: "read",
  //     resource: "club",
  //   },
  // },

];

export default LandingRoutes;
